import { render } from "./ContentHeader.vue?vue&type=template&id=a34656aa"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=a34656aa&lang=css"

import exportComponent from "/var/www/corfits.id/e-budgeting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__